export default "__VITE_ASSET__892123d9__"